import { useWeigtedCenterResultsSelector } from '~/store/frontendState/mapTools/weightedCenter/weightedCenter.selectors';
import { useMap } from '../mapContext';
import { RadarMarkerOverlay } from '../mapOverlays/radarMarker/radarMarker.component.overlay';
import { WeightedCenterFloatingUIContainer } from './weightedCenterFloatingUI.container';

export const WeightedCenterOverlayContainer = () => {
  const map = useMap();
  const results = useWeigtedCenterResultsSelector();

  return (
    <>
      {!results.isLoading && !results.isError && results.weightedCenter && (
        <RadarMarkerOverlay
          position={results.weightedCenter}
          map={map}
        />
      )}
      <WeightedCenterFloatingUIContainer />
    </>
  );
};
